import { connect } from "react-redux";
import JainSymbol from "../../../images/Banner/jainism-outline3.svg";
// lord-ganesh.png (images/Banner), upscaled and cleaned into a mask so it takes the theme's gold
import GaneshMark from "../../../images/royal-mahal/ganesh.png";
import { isJainInvite } from "../helpers";
import { ganeshChant } from "../../Utsav/helpers";

/**
 * The blessing emblem at the top of the card: Shree Ganesh by default, or the
 * Jain symbol when the invite's religion is "jain" (as the earlier banner did).
 */
const SacredMark = ({ religion, chant, className = "", showChant = true }) => {
  const jain = isJainInvite(religion);
  return (
    <div className={`rm-sacred ${className}`}>
      {jain ? (
        <span
          className="rm-sacred__jain"
          role="img"
          aria-label="Jain symbol"
          style={{ WebkitMaskImage: `url(${JainSymbol})`, maskImage: `url(${JainSymbol})` }}
        />
      ) : (
        <span
          className="rm-sacred__ganesha"
          role="img"
          aria-label="Shree Ganesh"
          style={{ WebkitMaskImage: `url(${GaneshMark})`, maskImage: `url(${GaneshMark})` }}
        />
      )}
      {showChant && (
        <p className="rm-kicker rm-sacred__chant">
          {jain ? "|| Shree Mahaveeray Namah ||" : chant}
        </p>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  religion: state.inviteDetails.invite?.religion,
  chant: ganeshChant(state.inviteDetails.invite),
});

export default connect(mapStateToProps)(SacredMark);
